import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { SecondaryButton } from '@/components/buttons/SecondaryButton/SecondaryButton';
import { PrimaryButton } from '@/components/buttons/PrimaryButton/PrimaryButton';

interface ExitSetupConfirmDialogProps {
  isOpen: boolean;
  onStay: () => void;
  onLeave: () => void;
}

export const ExitSetupConfirmDialog: React.FC<ExitSetupConfirmDialogProps> = ({
  isOpen,
  onStay,
  onLeave,
}) => (
  <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onStay()}>
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-[100002] bg-black/50" />
      <Dialog.Content className="fixed top-1/2 left-1/2 z-[100002] w-[360px] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white p-6 shadow-xl">
        <Dialog.Title className="mb-2 text-base font-semibold text-neutral-900">
          Leave setup?
        </Dialog.Title>
        <Dialog.Description className="mb-6 text-sm leading-relaxed text-neutral-500">
          Automations can not be saved as drafts. Any progress you have made will be lost if you
          leave now.
        </Dialog.Description>
        <div className="flex justify-end gap-3">
          <SecondaryButton text="Stay" icon={null} onClick={onStay} />
          <PrimaryButton text="Leave" icon={null} onClick={onLeave} />
        </div>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
